function joinNonEmpty(separator: string, parts: Array<string | null | undefined>): string {
  return parts.filter((part) => part && part.trim().length > 0).join(separator);
}

/** "Straße Nr." line of a participant address; empty string when both parts are missing. */
export function formatParticipantStreetLine(
  street: string | null | undefined,
  houseNumber: string | null | undefined
): string {
  return joinNonEmpty(" ", [street, houseNumber]);
}

/** "PLZ Ort" line of a participant address; empty string when both parts are missing. */
function formatParticipantCityLine(zipCode: string | null | undefined, city: string | null | undefined): string {
  return joinNonEmpty(" ", [zipCode, city]);
}

/** Full single-line participant address ("Straße Nr., PLZ Ort"); empty string when nothing is set. */
export function formatParticipantAddress(
  street: string | null | undefined,
  houseNumber: string | null | undefined,
  zipCode: string | null | undefined,
  city: string | null | undefined
): string {
  return joinNonEmpty(", ", [
    formatParticipantStreetLine(street, houseNumber),
    formatParticipantCityLine(zipCode, city),
  ]);
}
